module.exports = __webpack_public_path__ + "img/dsci0014.a850d62e.jpg";